import LlTooltip from "@/components/LlTooltip.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import axios from "axios";
import ExportJson from "@/services/ExportJsonService";
import RouteService from "@/services/RouteService";
import invoicesSummaryExport from "./invoicesSummaryExport";
export default {
  name: "InvoicesSummaryModal",
  uiView: "invoice",
  props: {
    stateParams: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  components: {
    LlSecondaryButton,
    LlTooltip
  },
  data() {
    return {
      invoicesSummary: undefined,
      loading: true,
      value: undefined,
      loadingValue: true,
      showValue: false,
      valueError: undefined,
      includeNumbers: false,
      includeDates: false,
      expand: false
    };
  },
  async mounted() {
    this.getInvoiceSummary();
    this.getInvoiceValue();
  },
  computed: {
    headerText() {
      const {
        state
      } = this.invoicesSummary?.invoice;
      if (state.draft) return "Draft";
      if (state.review) return "Review";
      if (state.approved) return "Approved";
      return "Invoice";
    }
  },
  methods: {
    async getInvoiceValue() {
      // -- consider uncommenting this if you are testing a bunch to avoid incurring openai cost
      // this.value = "test";
      // this.loadingValue = false;
      // this.showValue = true;
      // return;

      const me = await this.userService.getMe();
      this.showValue = me.features.openai;
      this.valueError = undefined;
      if (!this.showValue) return;
      const invoiceId = this.routeService.params().id;
      this.loadingValue = true;
      try {
        const response = await axios({
          url: `/invoices/${invoiceId}/value`
        });
        const text = response.data.choices[0].message.content;
        const sections = text.split("\n\n");
        this.value = sections.length ? sections[sections.length - 1] : text;
        const {
          analytics
        } = window;
        if (analytics) {
          analytics.track("OpenAI Summary", {
            invoiceId: this.invoicesSummary.invoice.id,
            invoiceReference: this.invoicesSummary.invoice.reference,
            summaryDates: this.includeDates,
            summaryNumbers: this.includeNumbers,
            summaryExpand: this.expand
          });
        }
      } catch (err) {
        console.error("loading value", err);
        this.valueError = `Failed to generate summary -- ${err}`;
      }
      this.loadingValue = false;
    },
    async getInvoiceSummary() {
      this.routeService = new RouteService(this);
      const invoiceId = this.routeService.params().id;
      this.loading = true;
      try {
        this.invoicesSummary = await this.leanLawApi.getInvoiceSummary({
          id: invoiceId
        });
      } catch (err) {
        this.handleCloseButton();
        this.alerts.error(`Failed to load Invoice Summary`);
      }
      this.loading = false;
    },
    handleCloseButton() {
      this.routeService.go("^");
    },
    feedback(sentiment) {
      const {
        analytics
      } = window;
      if (analytics) {
        analytics.track("OpenAI Feedback", {
          sentiment,
          invoiceId: this.invoicesSummary.invoice.id,
          invoiceReference: this.invoicesSummary.invoice.reference,
          summaryDates: this.includeDates,
          summaryNumbers: this.includeNumbers,
          summaryExpand: this.expand,
          summaryText: this.value
        });
        this.alerts.success("Thank you for your feedback. It will really help us improve the summary.");
      }
    },
    exportExcel() {
      const exportJson = new ExportJson();
      const formatExcel = invoicesSummaryExport(this.invoicesSummary, this.hoursDecimal, this.formatCurrency);
      exportJson.downloadCsv(formatExcel, "Invoice Summary");
    }
  }
};